import React from 'react';
import { Link } from '@chakra-ui/react';

interface LinkTextProps {
    text: string;
    links: Record<string, string>;
}

const TextWithLinks = ({ text, links }: LinkTextProps) => {
    let fragments: (string | React.ReactElement)[] = [text];

    for (const [sub, link] of Object.entries(links)) {
        const updated = [];

        for (const t of fragments) {
            if (typeof t === 'string' && t.includes(sub)) {
                const p = t.indexOf(sub);

                updated.push(t.substring(0, p));
                updated.push(
                    <Link href={link} target="-blank" rel="noreferrer">
                        {sub}
                    </Link>,
                );
                updated.push(t.substring(p + sub.length));
            } else {
                updated.push(t);
            }
        }

        fragments = updated;
    }

    return (
        <>
            {fragments.map((f, i) => (
                <React.Fragment key={i}>{f}</React.Fragment>
            ))}
        </>
    );
};

export default TextWithLinks;
